<template>
  <page :class="pageStyles">
    <!-- Background expanding out to the right -->
    <div v-if="promoteAppDownload" class="hidden l:grid w-full h-full grid-cols-12 fixed">
      <div class="col-span-4" :class="leftSideCustomBackgroundColor" />
      <div class="col-start-9 col-span-4 bg-pale-mint-grey" />
    </div>

    <header-component :content-props="{ hasUserMenu: true, hasUpgradeLink: false }" />

    <div
      class="container grid grid-cols-12 pb-12 m:pb-16 relative h-full lg:px-0"
      :class="leftSideCustomBackgroundColor"
    >
      <div class="col-span-full m:col-span-10 l:col-span-6 pt-6 m:pt-8 l:pt-16">
        <slot name="content" />

        <div>
          <store-badges-controller
            :button-code="storeBadgesButtonCode"
            :web-to-mobile-flag="webToMobileFlag"
            v-if="promoteAppDownload"
            class="l:hidden mt-8 m:max-w-74"
          />
          <a
            v-if="promoteAppDownload && !hideContinueBrowser"
            class="text-center m:text-left block text-mid-grey underline l:hidden m:max-w-74"
            :href="continueOnBrowserLink"
          >
            {{ $t("continueBrowser") }}
          </a>
          <button-link v-if="!!ctaCopy" :href="ctaTarget" variant="product-interaction" class="block mt-8 m:max-w-74">
            {{ ctaCopy }}
          </button-link>
        </div>

        <notification v-if="$slots.infobox" type="notification" class="mt-8">
          <slot name="infobox" />
        </notification>
      </div>

      <div
        v-if="promoteAppDownload"
        class="hidden l:flex row-span-3 col-start-8 col-span-5 flex-col justify-center text-center items-center bg-pale-mint-grey pl-16"
      >
        <app-download-qr-code />
        <p class="w-full mb-8" v-html="$t('scan')" />
        <a v-if="!hideContinueBrowser" class="w-full text-mid-grey underline" :href="continueOnBrowserLink">
          {{ $t("continueBrowser") }}
        </a>
      </div>

      <div :class="imageContainerStyles">
        <slot name="image" />
      </div>
    </div>
  </page>
</template>

<script>
import Page from "@/shared/page"
import HeaderComponent from "@/features/header/components"
import StoreBadgesController from "@/shared/store-badges/store-badges-controller"
import ButtonLink from "@/component-library/button-link"
import AppDownloadQrCode from "@/shared/store-badges/app-download-qr-code"
import Notification from "@/shared/notification"
import globals from "@/utils/globals"
import { cookie } from "@/utils/cookie"

export default {
  name: "SuccessPageLayout",
  components: {
    Notification,
    AppDownloadQrCode,
    ButtonLink,
    HeaderComponent,
    StoreBadgesController,
    Page
  },
  libraryPath: globals.routes.library,
  forYouPath: globals.routes.forYou,
  props: {
    ctaCopy: {
      type: String,
      default: null
    },
    ctaTarget: {
      type: String,
      default: globals.routes.library
    },
    storeBadgesButtonCode: {
      type: String,
      default: null
    },
    promoteAppDownload: {
      type: Boolean,
      default: true
    },
    webToMobileFlag: {
      type: String,
      default: null
    },
    hideContinueBrowser: {
      type: Boolean,
      default: false
    },
    customBackgroundColor: {
      type: String,
      default: null
    }
  },
  computed: {
    pageStyles() {
      return {
        [this.customBackgroundColor]: !!this.customBackgroundColor && !this.promoteAppDownload
      }
    },
    leftSideCustomBackgroundColor() {
      return {
        [this.customBackgroundColor]: !!this.customBackgroundColor && this.promoteAppDownload
      }
    },
    imageContainerStyles() {
      return [
        "col-span-full m:col-span-10 m:col-start-2",
        this.promoteAppDownload ? "l:col-span-6" : "l:mt-24 l:col-span-5 l:col-start-8"
      ].join(" ")
    },
    continueOnBrowserLink() {
      const redirectLink = cookie("bk_after_purchase_target_url")

      if (redirectLink) {
        return redirectLink
      }

      return this.$options.forYouPath
    }
  },
  i18n: {
    messages: {
      en: {
        scan: "<strong>Scan this QR code</strong> with your mobile device to download the Blinkist app.",
        continueBrowser: "or continue in the browser"
      },
      de: {
        scan: "<strong>Scanne diesen QR-Code</strong> mit deinem Smartphone oder Tablet, um dir die Blinkist App zu laden. ",
        continueBrowser: "Oder fahre im Browser fort"
      },
      es: {
        scan: "<strong>Escanea este código QR</strong> con tu dispositivo móvil para descargar la app de Blinkist.",
        continueBrowser: "O, continúa en tu navegador"
      }
    }
  }
}
</script>
